import { ref } from "vue";
import { defineStore } from "pinia";
import {
    Lloyds3DSMethodDataResponse,
    LloydsChallengeDataResponse,
} from "@/helpers/interfaces/providers";

/**
 * Store for managing Lloyds-specific state, such as loading the Lloyds SDK,
 * storing 3DS method and challenge data, and tracking whether this data has
 * been consumed. This store is designed to be used in conjunction with the main
 * checkout store to handle payment processing with Lloyds.
 */
export const useLloydsStore = defineStore(
    "lloyds",
    () => {
        const loadLloydsScript = ref<boolean>(false);
        const lloyds3DSMethodData = ref<Lloyds3DSMethodDataResponse | null>(
            null,
        );
        const lloydsChallengeData = ref<LloydsChallengeDataResponse | null>(
            null,
        );
        const lloyds3DSMethodDataConsumed = ref<boolean>(false);
        const lloydsChallengeDataConsumed = ref<boolean>(false);

        function setLoadLloydsScript(load: boolean) {
            loadLloydsScript.value = load;
        }

        function setLloyds3DSMethodData(
            methodData: Lloyds3DSMethodDataResponse | null,
        ) {
            lloyds3DSMethodData.value = methodData;
        }

        function setLloydsChallengeData(
            challengeData: LloydsChallengeDataResponse | null,
        ) {
            lloydsChallengeData.value = challengeData;
        }

        function setLloyds3DSMethodDataConsumed(consumed: boolean) {
            lloyds3DSMethodDataConsumed.value = consumed;
        }

        function setLloydsChallengeDataConsumed(consumed: boolean) {
            lloydsChallengeDataConsumed.value = consumed;
        }

        return {
            loadLloydsScript,
            lloyds3DSMethodData,
            lloydsChallengeData,
            lloyds3DSMethodDataConsumed,
            lloydsChallengeDataConsumed,
            setLoadLloydsScript,
            setLloyds3DSMethodData,
            setLloydsChallengeData,
            setLloyds3DSMethodDataConsumed,
            setLloydsChallengeDataConsumed,
        };
    },
    {
        persist: {
            pick: [
                "loadLloydsScript",
                "lloyds3DSMethodData",
                "lloydsChallengeData",
                "lloyds3DSMethodDataConsumed",
                "lloydsChallengeDataConsumed",
            ],
            storage: sessionStorage,
        },
    },
);
